import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManagerConfigRelaysPage } from './manager-config-relays.page';

const routes: Routes = [
  {
    path: '',
    component: ManagerConfigRelaysPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerConfigRelaysPageRoutingModule {}
